import {IFamilyMembers} from '../../models/record-medical-inherited-family';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'getCountDiseaseParents'
})
export class GetCountDiseaseParentsPipe implements PipeTransform {

  transform(parents: IFamilyMembers[]): number {
    return parents.reduce((prev, current) => {
      return prev += current.quantity;
    }, 0);
  }

}
